module.exports = __webpack_public_path__ + "media/images/crafts/crafts_top-98d6eb76092f5745bf22b10278b5ef5d.jpg";